export default __webpack_public_path__ + "static/media/m_dashboard.8035f42e.svg";